define.alias("shared/components/shared/profile-categorization/selected-types", "settings/components/shared/profile-categorization/selected-types");